import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

if (environment.production) {
  // Sentry.init({
  //   dsn:
  //     'https://1d59524f06234148b8e22f6606e87a3a@o388884.ingest.sentry.io/5647960',
  //   integrations: [
  //     new Integrations.BrowserTracing({
  //       tracingOrigins: ['localhost', 'https://api.litofarma.com/api'],
  //       routingInstrumentation: Sentry.routingInstrumentation,
  //     }),
  //   ],

  //   // We recommend adjusting this value in production, or using tracesSampler
  //   // for finer control
  //   tracesSampleRate: 0.2,
  // });

  enableProdMode();
  if (window) {
    window.console.log = () => {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
